import BaseComponent from "@js/components/base_component.jsx";
import EuiReceivingDomainsForm from "@js/components/eui/receiving_domains/form.jsx";

class EuiReceivingDomainsShow extends BaseComponent {

  render() {
    return (
      <EuiReceivingDomainsForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiReceivingDomainsShow;
